<template>
    <v-footer dark padless>
        <v-card
            width="100%"
            flat
            tile
            class="indigo lighten-1 white--text text-center"
        >
            <v-card-text>
                <v-btn
                    v-for="(item, index) in items"
                    :key="index"
                    class="mx-4 white--text"
                    :href="item.href"
                    :title="item.text"
                    target="_blank"
                    icon
                >
                    <v-icon size="24px">
                        {{ item.icon }}
                    </v-icon>
                </v-btn>
            </v-card-text>

            <v-card-text class="white--text pt-0">
                Tận tâm trên từng đơn hàng
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text">
                ©2022 — <strong>All rights reserved by Isaura Bot</strong>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    name: "Home",

    data() {
        return {
            items: [
                {
                    icon: "mdi-facebook",
                    href: "https://fb.com/100063182980799",
                    text: "Facebook Isaura",
                },
                {
                    icon: "mdi-linkedin",
                    href: "#",
                    text: "linkedin",
                },
                {
                    icon: "mdi-youtube",
                    href: "https://www.youtube.com/channel/UCHJccUBgbPu7ETkr9dDub1A",
                    text: "Youtube Isaura",
                },
            ],
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.theme--light.v-footer.bot-footer {
    background-repeat: repeat;
    background-image: url('/public/images/templates/footer-bg-black.jpg');
}
</style>




// WEBPACK FOOTER //
// footer.vue